import React from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import Table from '../../components/Table'
import helper from "../../utils/helper"
import auth from "../../utils/auth"
import cfg from "../../utils/config"
import axios from "axios"
import tourManager from "../../tours"

class ComandoCustomizado extends React.Component {
    state = {
        comandoId: null,
        equipamentoId: null,
        tipoComunicacao: null,
        dataTableComandos: [],
        detalhes: { descricao: "", estrutura_comando: "" },
        lnsConfig: { formato: "hex", f_port: "", confirmed: false },
        protocoloCarregado: false,
        parametros: { nome_parametro: "", id: "", tipo: "text", selectValues: [] },
        descValor: { descricao: "", valor: "" },
        buttonParametrosTestar: true,
        openModal: false,
        editIndex: "",
        buttonSalvar: true,
        stringTeste: "",
        paramsCard: {}
    }

    handleChangeComandos = (e) => {
        let { detalhes, buttonParametrosTestar } = this.state

        detalhes[e.target.id] = e.target.value
        detalhes[e.target.id][0] == " " ? detalhes[e.target.id] = "" : ""

        if (detalhes["descricao"] != "" && detalhes["estrutura_comando"] != "") {
            buttonParametrosTestar = false
        } else {
            buttonParametrosTestar = true
        }

        this.setState({ detalhes, buttonParametrosTestar, comandoTest: "", buttonSalvar: true })
    }

    isLnsInterno = () => this.state.tipoComunicacao === 'lns_interno'

    parseConfiguracao = (configuracao) => {
        if (!configuracao) return {}
        if (typeof configuracao === "string") {
            try {
                return JSON.parse(configuracao) || {}
            } catch (err) {
                return {}
            }
        }
        return configuracao
    }

    resolveEquipamentoId = (equipamento) => {
        if (equipamento == null || equipamento === "") return null
        if (typeof equipamento === "object") return equipamento.id ?? null
        return equipamento
    }

    handleChangeLns = (e) => {
        let { lnsConfig } = this.state
        const { id, type, value, checked } = e.target

        if (type === "checkbox") {
            lnsConfig[id] = checked
        } else if (id === "f_port") {
            if (value === "" || /^[1-9]\d*$/.test(value)) {
                lnsConfig.f_port = value
            }
        } else {
            lnsConfig[id] = value
        }

        this.setState({ lnsConfig })

        const span = document.getElementById(`validacao-${id}`)
        if (span) span.classList.add("hdv-noshow-item")
    }

    getEquipamento = (equipamentoId) => {
        if (!equipamentoId) {
            this.setState({ protocoloCarregado: true })
            return
        }

        const userInfo = auth.getUserInfo()

        axios({
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/equipamento/' + equipamentoId + '/',
            method: "GET",
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(res => {
            this.setState({
                equipamentoId: res.data?.id ?? equipamentoId,
                tipoComunicacao: res.data?.tipo_comunicacao ?? null,
                protocoloCarregado: true
            })
        }).catch((error) => {
            this.setState({ protocoloCarregado: true })
            console.error(error)
        })
    }

    validateLnsFields = () => {
        if (!this.isLnsInterno()) return true

        const { formato, f_port } = this.state.lnsConfig
        let valid = true

        const formatoSpan = document.getElementById("validacao-formato")
        if (!formato || !["hex", "base64"].includes(formato)) {
            formatoSpan?.classList.remove("hdv-noshow-item")
            valid = false
        } else {
            formatoSpan?.classList.add("hdv-noshow-item")
        }

        const fPortSpan = document.getElementById("validacao-f_port")
        const fPortRaw = String(f_port ?? "").trim()
        const fPortNumber = Number(fPortRaw)

        if (fPortRaw === "" || !Number.isInteger(fPortNumber) || fPortNumber < 1) {
            fPortSpan?.classList.remove("hdv-noshow-item")
            valid = false
        } else {
            fPortSpan?.classList.add("hdv-noshow-item")
        }

        return valid
    }

    componentDidMount() {
        if (this.props.match.params.idComando) {
            this.setState({ comandoId: this.props.match.params.idComando })
            this.getData(this.props.match.params.idComando)
        } else {
            const equipamentoId = this.props.match.params.id || this.props.location?.state?.id
            const tipoFromState = this.props.location?.state?.tipo_comunicacao

            this.setState({
                equipamentoId,
                protocoloCarregado: Boolean(tipoFromState),
                ...(tipoFromState ? { tipoComunicacao: tipoFromState } : {})
            })
            this.getEquipamento(equipamentoId)
        }
    }

    getData = (comandoId) => {
        const userInfo = auth.getUserInfo()
        this.setState({ loading: true })

        axios({
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/comando-customizado/' + comandoId,
            method: "GET",
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(res => {
            let detalhes = this.state.detalhes
            detalhes["descricao"] = res.data?.descricao
            detalhes["estrutura_comando"] = res.data?.estrutura
            let parametros = helper.parseComandoParametros(res.data?.parametros)

            const equipamento = res.data?.equipamento
            const equipamentoId = this.resolveEquipamentoId(equipamento)
            const tipoComunicacao = typeof equipamento === "object" && equipamento !== null
                ? equipamento.tipo_comunicacao ?? null
                : null

            const configuracao = this.parseConfiguracao(res.data?.configuracao)
            const lnsConfig = {
                formato: ["hex", "base64"].includes(configuracao?.formato) ? configuracao.formato : "hex",
                f_port: configuracao?.f_port ?? "",
                confirmed: configuracao?.confirmed === true || configuracao?.confirmed === "true"
            }

            this.setState({
                detalhes,
                buttonParametrosTestar: false,
                dataTableComandos: parametros,
                loading: false,
                equipamentoId,
                tipoComunicacao,
                lnsConfig,
                protocoloCarregado: Boolean(tipoComunicacao) || !equipamentoId
            })

            if (!tipoComunicacao && equipamentoId) {
                this.getEquipamento(equipamentoId)
            }
        }).catch((error) => {
            this.setState({ loading: false, protocoloCarregado: true })
            console.error(error)
        })
        this.setState({ buttonParametrosTestar: false })
    }

    handleChangeParametros = (e) => {
        let parametros = Object.assign({}, this.state.parametros)
        let descValor = Object.assign({}, this.state.descValor)

        if (e.target.id == "descricao" || e.target.id == "valor") {
            descValor[e.target.id] = e.target.value
            descValor[e.target.id][0] == " " ? descValor[e.target.id] = "" : ""
        } else {
            parametros[e.target.id] = e.target.value
            parametros[e.target.id][0] == " " ? parametros[e.target.id] = "" : ""
        }

        if (parametros["tipo"] == "text") {
            descValor["descricao"] = ""
            descValor["valor"] = ""
        }

        this.setState({ parametros: parametros, descValor: descValor })
    }

    validationTableParametros = () => {
        let { descValor } = this.state

        let validated = []

        if (descValor.descricao == "") {
            document.getElementById("validacao-descricao").classList.remove("hdv-noshow-item")
        } else {
            document.getElementById("validacao-descricao").classList.add("hdv-noshow-item")
            validated.push("descricao")
        }

        if (descValor.valor == "") {
            document.getElementById("validacao-valor").classList.remove("hdv-noshow-item")
        } else {
            document.getElementById("validacao-valor").classList.add("hdv-noshow-item")
            validated.push("valor")
        }

        return validated
    }

    validationTableComandos = () => {
        let { parametros } = this.state
        let validated = []

        if (parametros.nome_parametro == "") {
            document.getElementById("validacao-nome_parametro").classList.remove("hdv-noshow-item")
        } else {
            document.getElementById("validacao-nome_parametro").classList.add("hdv-noshow-item")
            validated.push("nome_parametro")
        }

        if (parametros.id == "") {
            document.getElementById("validacao-id").classList.remove("hdv-noshow-item")
        } else {
            document.getElementById("validacao-id").classList.add("hdv-noshow-item")
            validated.push("id")
        }

        if (validated.length == 2) {
            if (parametros.tipo == "select" && parametros.selectValues.length == 0) {
                helper.dispatchEvent("showAviso", {
                    message: 'É preciso adicionar um item na tabela!',
                    callback: () => this.setState({ openModal: false })
                })
            }
            else {
                this.addTableComandos()
            }
        }
    }

    addTableParametros = (event) => {
        event.preventDefault()

        let temp = this.state.descValor
        let parametros = this.state.parametros

        if (this.validationTableParametros().length == 2) {
            parametros.selectValues.push({
                descricao: temp.descricao,
                valor: temp.valor
            })
            temp.descricao = ""
            temp.valor = ""
        }

        document.getElementById("descricao").focus()
        this.setState({ parametros: parametros, descValor: temp })
    }

    deleteTableParametros = (deleteIndex) => {
        let temp = this.state.parametros

        let deletado = temp.selectValues.filter((valor, index) => index != deleteIndex)

        temp.selectValues = deletado

        this.setState({ parametros: temp })
    }

    checkId = (dataTableComandos, parametros, index) => {
        let validatedId = false

        if (index != "" && dataTableComandos[index].id == parametros.id) {
            validatedId = true
        } else {
            let filter_id = dataTableComandos.filter((valor, index) => {
                return valor.id == parametros.id
            })

            filter_id.length > 0 ? validatedId = false : validatedId = true
        }

        return validatedId
    }

    addTableComandos = () => {
        let { dataTableComandos, parametros, editIndex } = this.state

        let temp = {
            nome_parametro: parametros.nome_parametro,
            id: parametros.id,
            tipo: parametros.tipo,
            selectValues: parametros.selectValues,
        }

        if (this.checkId(dataTableComandos, parametros, editIndex) == true) {
            editIndex != "" ? dataTableComandos[editIndex] = temp : dataTableComandos.push(temp)
            parametros.tipo == "text" ? temp.selectValues = [] : ""
            this.clearStateModal()
        } else {
            helper.dispatchEvent("showAviso", {
                message: 'Este id já está cadastrado, cadastre outro id!',
                callback: () => this.setState({ openModal: false })
            })
        }

        this.setState({ dataTableComandos, comandoTest: "", buttonSalvar: true })
    }

    deleteTableComandos = (deleteItem) => {
        let dataTableComandos = this.state.dataTableComandos
        let filter = dataTableComandos.filter((valor) => valor.id != deleteItem)

        this.setState({ dataTableComandos: filter, comandoTest: "", buttonSalvar: true })
    }

    editTableComandos = (itemEdit) => {
        let dataTableComandos = JSON.parse(JSON.stringify(this.state.dataTableComandos))

        let edit = dataTableComandos.filter((valor) => itemEdit == valor.id)
        let index = dataTableComandos.findIndex((indexItem) => indexItem == edit[0])

        if (edit[0].tipo == "select") {
            edit[0].valor = ""
        }

        this.setState({ parametros: edit[0], editIndex: String(index), openModal: true })
    }

    clearStateModal = () => {
        this.setState({
            parametros: { nome_parametro: "", id: "", tipo: "text", selectValues: [] },
            descValor: { descricao: "", valor: "" },
            openModal: false,
            editIndex: "",
        })
    }

    saveAction = () => {
        if (!this.state.protocoloCarregado) return
        if (!this.validateLnsFields()) return

        let { detalhes, dataTableComandos, comandoId, equipamentoId, lnsConfig } = this.state
        let requestURL = ''
        let method = ''
        let userInfo = auth.getUserInfo()

        if (comandoId) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/comando-customizado/${comandoId}/`
            method = "PATCH"
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/comando-customizado/'
            method = "POST"
        }

        const data = {
            descricao: detalhes.descricao,
            estrutura: detalhes.estrutura_comando,
            parametros: JSON.stringify(dataTableComandos),
            equipamento: String(equipamentoId ?? this.props.match.params.id),
        }

        if (this.isLnsInterno()) {
            data.formato = lnsConfig.formato
            data.f_port = parseInt(lnsConfig.f_port, 10)
            data.confirmed = Boolean(lnsConfig.confirmed)
        }

        axios({
            method: method,
            url: requestURL,
            data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        })
            .then(() => {
                helper.dispatchEvent("showAviso", {
                    message: `Comando ${method === "POST" ? 'Criado' : 'Editado'} com sucesso`,
                    callback: this.props.history.goBack
                })
            })
            .catch((error) => {
                const data = error?.response?.data

                if (typeof data === "string") {
                    helper.dispatchEvent("showAviso", { message: data })
                    return
                }

                if (data && typeof data === "object") {
                    const erros = Object.entries(data)
                    let showedField = false

                    erros.forEach(([key, value]) => {
                        const span = document.getElementById(`validacao-${key}`)
                        if (span) {
                            span.classList.remove("hdv-noshow-item")
                            span.innerHTML = Array.isArray(value) ? value[0] : value
                            showedField = true
                        }
                    })

                    if (!showedField) {
                        helper.dispatchEvent("showAviso", {
                            message: "Não foi possível salvar o comando. Verifique os campos e tente novamente."
                        })
                    }
                    return
                }

                console.error(error)
            })
    }

    test = () => {
        let { buttonSalvar, dataTableComandos, detalhes } = this.state
        let string_formula = detalhes.estrutura_comando
        let paramsCard = {}

        if (dataTableComandos.length > 0) {
            dataTableComandos.map((valor) => {
                if (string_formula.includes(`{${valor.id}}`)) {
                    string_formula = string_formula.replace(`{${valor.id}}`, document.getElementById(valor.id).value)
                    paramsCard[valor.id] = document.getElementById(valor.id).value

                    if (valor.tipo === 'text') {
                        document.getElementById(valor.id).value === "" ? string_formula = "" : null
                    }
                } else {
                    string_formula = ""
                }
            })
        } else {
            string_formula = string_formula.replace(/[{}]/g, "")
        }

        if (string_formula == "") {
            string_formula = "Fórmula inválida!"
            buttonSalvar = true
        } else {
            buttonSalvar = false
        }

        this.setState({ stringTeste: string_formula, buttonSalvar, paramsCard: paramsCard })
    }

    openModal = () => {
        this.setState({ openModal: true })
    }

    render() {
        let { parametros, dataTableComandos } = this.state

        const columnsComandos = [
            {
                Header: "Descrição",
                Accessor: "nome_parametro",
            }, {
                Header: "Tipo Valor",
                Accessor: "tipo",
                Cell: (value) => {
                    if (value.tipo === "text") return <span>Valor Único</span>
                    else return <span>Multiplos Valores</span>
                }
            }, {
                Header: "id",
                Accessor: "id",
            }, {
                Header: "",
                Accessor: "",
                Cell: (item) => {
                    return (
                        <div className="d-flex justify-content-end">
                            <button
                                onClick={() => this.editTableComandos(item.id)}
                                className="hdv-chart-edit hdv-automacao-delete-button d-flex align-items-center"
                                style={{ color: '#333', width: '60px', border: '1px solid #cacaca' }}>
                                <i className="fa fa-pen" style={{ fontSize: '22px' }}></i> Editar
                            </button>
                            <button
                                style={{ color: '#fff', width: '65px' }}
                                onClick={() => this.deleteTableComandos(item.id)}
                                className="hdv-chart-close  hdv-btn-red hdv-automacao-delete-button d-flex align-items-center">
                                <i className="fa fa-times" style={{ fontSize: '22px' }}></i> Excluir
                            </button>
                        </div>
                    )
                }
            }
        ]

        return (
            <>
                <Modal size="lg" isOpen={this.state.openModal} data-tour="comando-param-modal">
                    <ModalHeader>Parâmetros</ModalHeader>
                    <ModalBody>
                        <form className="hdv-form-default" id="formParametros">
                            <div className="row">
                                <div className="col-md-6" data-tour="comando-param-nome">
                                    <label htmlFor="nome_parametro" className="required">Nome</label>
                                    <input value={this.state.parametros.nome_parametro} id="nome_parametro" type="text" onChange={this.handleChangeParametros}></input>
                                    <span id="validacao-nome_parametro" className="hdv-noshow-item">Campo não pode ser nulo!</span>
                                </div>
                                <div className="col-md-6" data-tour="comando-param-id">
                                    <label htmlFor="id" className="required">Id</label>
                                    <input min={0} value={this.state.parametros.id} id="id" onChange={this.handleChangeParametros} type="text" placeholder=""></input>
                                    <span id="validacao-id" className="hdv-noshow-item">Campo não pode ser nulo!</span>
                                </div>
                            </div>
                            <div data-tour="comando-param-tipo">
                                <label htmlFor="" className="required">Tipo do valor</label>
                                <select value={this.state.parametros.tipo} id="tipo" onChange={this.handleChangeParametros}>
                                    <option value="text">Valor único</option>
                                    <option value="select">Múltiplos valores</option>
                                </select>
                            </div>
                            {this.state.parametros.tipo === "select" ?
                                <div className="row d-flex align-items-center" style={{ borderTop: '1px solid #cacaca', marginTop: '14px' }} data-tour="comando-param-opcao">
                                    <div className="col-md-5 hdv-form-default" data-tour="comando-param-opcao-descricao">
                                        <label htmlFor="descricao" className="required">Descrição</label>
                                        <input value={this.state.descValor.descricao} id="descricao" onChange={this.handleChangeParametros} type="text"></input>
                                        <span id="validacao-descricao" className="hdv-noshow-item">Campo não pode ser nulo!</span>
                                    </div>
                                    <div className="col-md-5 hdv-form-default" data-tour="comando-param-opcao-valor">
                                        <label htmlFor="valor" className="required">Valor</label>
                                        <input value={this.state.descValor.valor} type="text" id="valor" onChange={this.handleChangeParametros} placeholder=""></input>
                                        <span id="validacao-valor" className="hdv-noshow-item">Campo não pode ser nulo!</span>
                                    </div>
                                    <div className="col-md-2" style={{ margin: "20px 0px" }} data-tour="comando-param-opcao-adicionar">
                                        <label className="required">Adicionar</label>
                                        <button onClick={this.addTableParametros} className="btn-cadastro-parametros">
                                            <i className="fa fa-plus fa-2x"></i>
                                        </button>
                                    </div>
                                </div>
                                :
                                null
                            }
                        </form>
                        <div style={{ height: '200px', display: this.state.parametros.tipo == "text" ? "none" : "block", color: "#979797" }} className="table-responsive" data-tour="comando-param-opcoes-tabela">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Valor</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parametros.selectValues.map((valor, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{valor.descricao}</td>
                                                <td>{valor.valor}</td>
                                                <td>
                                                    <button onClick={() => this.deleteTableParametros(index)}
                                                        style={{ color: '#fff', width: '65px' }}
                                                        className="hdv-chart-close  hdv-btn-red hdv-automacao-delete-button d-flex align-items-center">
                                                        <i className="fa fa-times" style={{ fontSize: '22px' }}></i>
                                                        Excluir
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button id="button-cadastrar-parametros" data-tour="comando-param-confirmar" onClick={this.validationTableComandos} color="success">{this.state.editIndex != "" ? "Atualizar" : "Adicionar"}</Button>
                        <Button data-tour="comando-param-fechar" onClick={() => { this.setState({ openModal: false }); this.clearStateModal() }} color="default">Fechar</Button>
                    </ModalFooter>
                </Modal>

                <div className="hdv-render-div">
                    <div>
                        <div>
                            <div className="hdv-default-header mx-3">
                                <span className="screen-menu-desc" style={{ alignItems: 'center' }}>
                                    {this.state.comandoId ? <h4>Editar Comando</h4> : <h4>Cadastro De Comandos</h4>}
                                    <div className="gray-background">
                                        <i className="fa fa-hdd fa-2x"></i>
                                    </div>
                                    {auth.isMasterOrAdmin() ? (
                                    <span
                                        data-tour="help-comando-customizado"
                                        title="Ajuda"
                                        onClick={() => tourManager.start('comandos')}
                                        style={{ marginLeft: '10px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                        <i className="las la-question-circle hdv-help-tour-icon"></i>
                                    </span>
                                    ) : null}
                                </span>
                            </div>
                        </div>

                        <Tabs className="tabs-style">
                            <TabList>
                                <Tab data-tour="comando-tab-comando">Comando</Tab>
                                <Tab data-tour="comando-tab-parametros">Parâmetros</Tab>
                            </TabList>

                            <TabPanel>
                                <div className="form-flex">
                                    <div className="col-md-9">
                                        <form className="hdv-form-default">
                                            <div data-tour="comando-nome">
                                                <label htmlFor="descricao" className="required mt-0">Nome do Comando</label>
                                                <input id="descricao" value={this.state.detalhes.descricao} onChange={this.handleChangeComandos} type="text" placeholder="Digite o nome do comando..."></input>
                                                <span className="hdv-noshow-item">Campo não pode ser nulo!</span>
                                            </div>
                                            <div data-tour="comando-estrutura">
                                                <label htmlFor="estrutura_comando" className="required">Estrutura do Comando</label>
                                                <input id="estrutura_comando" value={this.state.detalhes.estrutura_comando} onChange={this.handleChangeComandos} type="text" placeholder="Exemplo: teste{ id }"></input>
                                                <span className="hdv-noshow-item">Campo não pode ser nulo!</span>
                                            </div>
                                            {this.isLnsInterno() && (
                                                <div className="row" data-tour="comando-lns">
                                                    <div className="col-md-4" data-tour="comando-formato">
                                                        <label htmlFor="formato" className="required">Formato</label>
                                                        <select id="formato" value={this.state.lnsConfig.formato} onChange={this.handleChangeLns}>
                                                            <option value="hex">Hex</option>
                                                            <option value="base64">Base64</option>
                                                        </select>
                                                        <span id="validacao-formato" className="hdv-noshow-item">Campo não pode ser nulo!</span>
                                                    </div>
                                                    <div className="col-md-4" data-tour="comando-f-port">
                                                        <label htmlFor="f_port" className="required">FPort</label>
                                                        <input
                                                            id="f_port"
                                                            type="number"
                                                            min="1"
                                                            step="1"
                                                            value={this.state.lnsConfig.f_port}
                                                            onChange={this.handleChangeLns}
                                                            onKeyDown={(e) => {
                                                                if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                                                                    e.preventDefault()
                                                                }
                                                            }}
                                                            placeholder="Exemplo: 2"
                                                        />
                                                        <span id="validacao-f_port" className="hdv-noshow-item">Informe um número inteiro a partir de 1.</span>
                                                    </div>
                                                    <div className="col-md-4 d-flex align-items-end" data-tour="comando-confirmed">
                                                        <label htmlFor="confirmed" style={{ display: "flex", alignItems: "center", gap: "8px", height: "44px", marginTop: 0, marginBottom: 0 }}>
                                                            <input
                                                                id="confirmed"
                                                                type="checkbox"
                                                                checked={this.state.lnsConfig.confirmed}
                                                                onChange={this.handleChangeLns}
                                                            />
                                                            Confirmado
                                                            <i
                                                                className="las la-info-circle"
                                                                style={{ cursor: "pointer", fontSize: "18px", position: "relative", top: "-2px", left: "-3px" }}
                                                                title="O que significa Confirmado?"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                    helper.dispatchEvent("showAviso", {
                                                                        message: "Confirmed Downlink no LoRaWAN é uma mensagem enviada pelo servidor para o dispositivo exigindo uma confirmação de recebimento.",
                                                                        callbackLabelClose: "Fechar",
                                                                    })
                                                                }}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                            <div data-tour="comando-formula">
                                                <label className="required">Fórmula do comando</label>
                                                <input style={{ fontWeight: 'bold', color: this.state.stringTeste != 'Fórmula inválida!' ? 'rgb(63, 217, 89)' : 'tomato' }} value={this.state.stringTeste} type="text" disabled placeholder="teste para ver a fórmula ..."></input>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="comandos-btn-editar py-2" style={{ width: "100%" }} data-tour="comando-valores-teste">
                                            <div className="comandos-parametros">
                                                {dataTableComandos.map((valor, index) => (
                                                    <div key={index}>
                                                        <label style={{ margin: "0", fontSize: '13px', display: "flex", flexDirection: "column", fontWeight: "bold" }}>
                                                            {valor.nome_parametro}
                                                        </label>
                                                        {(valor.tipo == "select")
                                                            ?
                                                            <select defaultValue={valor.id in this.state.paramsCard ? this.state.paramsCard[valor.id] : null} id={valor.id}>
                                                                {
                                                                    valor.selectValues.map((valor, optionIndex) => (
                                                                        <option value={valor.valor} key={optionIndex}>
                                                                            {valor.descricao} ({valor.valor})
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                            :
                                                            <input defaultValue={valor.id in this.state.paramsCard ? this.state.paramsCard[valor.id] : null} onChange={() => this.setState({ buttonSalvar: true })} id={valor.id} placeholder="Digite o valor..."></input>
                                                        }
                                                    </div>
                                                )
                                                )}
                                            </div>
                                        </div>
                                        <div className="mt-1 d-flex flex-column justify-content-center">
                                            <button id="btn-testar" data-tour="comando-testar" disabled={this.state.buttonParametrosTestar} onClick={this.test}>Testar</button>
                                        </div>
                                    </div>

                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div>
                                    <button
                                        data-tour="comando-novo-parametro"
                                        disabled={this.state.buttonParametrosTestar}
                                        onClick={this.openModal}
                                        className="hdv-btn-forms hdv-btn-green mb-2">
                                        Novo Parâmetro
                                    </button>
                                    <div data-tour="comando-parametros-tabela">
                                        <Table
                                            notEditFirstColum={true}
                                            search={false}
                                            config={false}
                                            data={dataTableComandos}
                                            loading={this.state.loading}
                                            columns={columnsComandos}
                                            onUpdate={(table) => this.setState({ table })}
                                        />
                                    </div>
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>

                    <div className="hdv-btn-group">
                        <button disabled={this.state.buttonSalvar || !this.state.protocoloCarregado} onClick={this.saveAction} className="hdv-btn-forms hdv-btn-green" data-tour="comando-salvar">Salvar e continuar</button>
                        <button onClick={this.props.history.goBack} className="hdv-btn-forms hdv-btn-orange">Cancelar</button>
                    </div>
                </div>
            </>
        )
    }
}

export default ComandoCustomizado